<template>
    <div class="footer-wrap">
      <div class="img-wrap">
        <img src="../assets/001.png" alt="" />
        <img src="../assets/002.png" alt="" />
      </div>
      <div class="copyright">
        <p>Copyright © 2021 www.chinampr.com</p>
        <p>中博协市场推广专委会 版权所有</p>
      </div>
      <div class="email">
        <p>电子邮箱</p>
        <p>info@chinampr.org</p>
      </div>
      <div class="icp-number">
        <p>备 案 号</p>
        <p>京ICP备2020045888号</p>
      </div>
    </div>
</template>

<style scoped lang="scss">
.footer-wrap {
  background: #373737;
  color: #ffffff;
  text-align: center;
  padding-bottom: 8vw;
  font-size: 3.2vw;
  .img-wrap {
    padding-top: 6.667vw;
    font-size: 0;
    img {
      width: 24.667vw;
      height: 29.333vw;
    }
    img:first-child {
      margin-right: 8.667vw;
    }
  }
  .copyright {
    margin-top: 5.333vw;
  }
  .email {
    margin-top: 6.667vw;
  }
  .icp-number {
    margin-top: 4vw;
  }
  p {
    margin-top: 0;
    margin-bottom: 1.333vw;
  }
}
</style>